<script>
  import { fetchO } from '../../oauth.js'
  import { tooltipable } from '../../components/tooltipable.js'

  let workoutsPerDay = {}
  let loading = false
  let workoutPlanColor = {}

  function entriesSorted(d) {
    const entries = Object.entries(d)
    entries.sort(function (a, b) {
      var keyA = a[0].toUpperCase() // ignore upper and lowercase
      var keyB = b[0].toUpperCase() // ignore upper and lowercase
      if (keyA < keyB) {
        return -1
      }
      if (keyA > keyB) {
        return 1
      }

      // keys must be equal
      return 0
    })
    return entries
  }

  function getDayKey(d) {
    return (
      d.getFullYear() +
      '-' +
      (d.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      d.getDate().toString().padStart(2, '0')
    )
  }

  function getWeekKey(d) {
    // Copy date so don't modify original
    d = new Date(d.getFullYear(), d.getMonth(), d.getDate())
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setDate(d.getDate() + 4 - (d.getDay() || 7))
    // Get first day of year
    var yearStart = new Date(d.getFullYear(), 0, 1)
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7)

    return d.getFullYear() + '-' + weekNo
  }

  const colors = [
    '#003f5c',
    '#665191',
    '#a05195',
    '#d45087',
    '#f95d6a',
    '#ff7c43',
    '#ffa600',
  ]
  let colorIndex = 0
  function getWorkoutPlan(workoutPlan) {
    // Adds the same color to the same plan

    // Check if there has already been a color assigned
    let color = workoutPlanColor[workoutPlan.id]
    if (!color) {
      // No color was assigned yet, assign a new one
      color = colors[colorIndex]
      colorIndex++
      if (colorIndex == colors.length) {
        colorIndex = 0
      }
      // Remember this color for the next time
      workoutPlanColor[workoutPlan.id] = color
    }

    // Assign a color to this particular plan
    workoutPlan.color = colors[colorIndex]

    return workoutPlan
  }

  const fetchSize = 13

  async function fetchWorkouts(weekStartDate) {
    loading = true

    // Sanitize start
    weekStartDate.setHours(0, 0, 0, 0)

    // Precreate the weeks
    for (let i = fetchSize; i >= 0; i--) {
      const d = new Date(weekStartDate)
      d.setDate(d.getDate() + i)

      //console.log('Week Creation: ' + d + '->' + getWeekKey(d))

      if (!workoutsPerDay[getWeekKey(d)]) {
        //console.log('Week does not exist yet, creating')
        workoutsPerDay[getWeekKey(d)] = {}

        // Precreate all weekdays in the week, not only the fetched ones
        for (let wi = fetchSize * -1; wi < fetchSize + 8; wi++) {
          const wd = new Date(weekStartDate)
          wd.setDate(wd.getDate() + wi)
          if (getWeekKey(wd) != getWeekKey(d)) {
            continue
          }

          workoutsPerDay[getWeekKey(wd)][getDayKey(wd)] = {
            workouts: [],
            weekDay: wd.getDay(),
            str: wd.toDateString(),
            loaded: false,
          }
        }
      }

      workoutsPerDay[getWeekKey(d)][getDayKey(d)].loaded = true
    }

    console.log('Weeks now', workoutsPerDay)

    // Calculate the end of the week which should be fetched`
    const weekEndDate = new Date(weekStartDate)
    weekEndDate.setDate(weekEndDate.getDate() + fetchSize)
    weekEndDate.setHours(23, 59, 59, 99)

    console.log('Fetching Workouts between', weekStartDate, weekEndDate)

    let url =
      '/workouts/?start_after=' +
      encodeURIComponent(weekStartDate.toISOString()) +
      '&start_before=' +
      encodeURIComponent(weekEndDate.toISOString())
    while (url) {
      const response = await fetchO(url)

      if (response.status == 200) {
        const j = await response.json()
        for (const workout of j.results) {
          // Add the Workout Plan
          workout.workout_plan = getWorkoutPlan(workout.workout_plan)

          // Get the Key for the workoutsPerDay dict
          const workoutStart = new Date(workout.start)

          // Concatenate to the workouts of the day
          workoutsPerDay[getWeekKey(workoutStart)][
            getDayKey(workoutStart)
          ].workouts = [
            ...workoutsPerDay[getWeekKey(workoutStart)][getDayKey(workoutStart)]
              .workouts,
            workout,
          ]
        }

        url = j.next
      } else {
        // Error while fetching, break the loop
        console.log('Error while fetching workouts', response)
        break
      }
    }
    loading = false
    console.log('Data now', workoutsPerDay)
  }

  let currentWeek = new Date()
  currentWeek.setDate(currentWeek.getDate() - fetchSize)

  // Fetch the last 7 days on load
  fetchWorkouts(currentWeek)

  function loadMore() {
    currentWeek.setDate(currentWeek.getDate() - fetchSize - 1)
    fetchWorkouts(currentWeek)
  }

  function getWorkoutTitle(workout) {
    if (workout.finish) {
      return 'Workout of ' + workout.workout_plan.title
    } else {
      return 'Unfinished Workout of ' + workout.workout_plan.title
    }
  }
</script>

<h2>Workouts</h2>
<div class="container" style="padding-left: 0; padding-right: 0;">
  {#each Object.entries(workoutsPerDay) as workoutWeekPair (workoutWeekPair[0])}
    <div class="row row-cols-1 row-cols-sm-7">
      {#each entriesSorted(workoutWeekPair[1]) as workoutDayPair (workoutDayPair[0])}
        <div
          class="col pb-3"
          class:bg-light={workoutDayPair[1].weekDay == 0 ||
            workoutDayPair[1].weekDay == 6}
        >
          <h6 class="mb-0">
            {#if workoutDayPair[1].loaded}{workoutDayPair[1].str}{:else}<i
                >{workoutDayPair[1].str}</i
              >{/if}
          </h6>

          <div class="overflow-scroll" style="height: 5em;">
            {#each workoutDayPair[1].workouts as workout (workout.id)}
              <span
                class="badge rounded-pill"
                style={'background-color: ' + workout.workout_plan.color}
                title={getWorkoutTitle(workout)}
                use:tooltipable
                ><i
                  class="bi"
                  class:bi-circle-fill={workout.finish}
                  class:bi-circle-half={!workout.finish}
                /></span
              >
            {/each}
          </div>
        </div>
      {/each}
    </div>
  {/each}
</div>

<button
  class="btn btn-primary"
  type="button"
  on:click={() => loadMore()}
  disabled={loading}
>
  {#if loading}
    <span
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    />
    Loading ...
  {:else}
    Load More
  {/if}
</button>

<svelte:head>
  <title>Fich Workouts</title>
</svelte:head>

<style>
  @media (min-width: 576px) {
    .row-cols-sm-7 > * {
      flex: 0 0 auto;
      width: 14.2857142857%; /* 100/7 */
    }
  }
</style>
